import {createSlice} from '@reduxjs/toolkit';

import type {DefaultRootState} from 'react-redux';

const initialState = {isHidingStackedDashboardFolders: false};

export const foldersSlice = createSlice({
  name: 'folders',
  initialState,
  reducers: {
    toggleIsHidingStackedDashboardFolders: (state) => {
      state.isHidingStackedDashboardFolders =
        !state.isHidingStackedDashboardFolders;
    },
  },
});

export const selectIsHidingStackedDashboardFolders = (
  state: DefaultRootState
) => state.folders.isHidingStackedDashboardFolders;

export const {toggleIsHidingStackedDashboardFolders} = foldersSlice.actions;
